import { AccommodationCard } from '@components/common/card/accommodation/AccommodationCard';
import React, { useState } from 'react';
import { SectionTitle } from '@components/common/section-title';
import { TestId } from '@components/test-ids';
import { Icon } from '@components/common/generic-icon';
import styled from '@emotion/styled';
import { useI18NextContext } from '@components/hooks';
import { TourHotel, TourVesselInfo } from '@model/tours';
import { ReadMore } from '@styles/common';
import { ThemeProps } from '@theme/base';

type AccommodationType = TourHotel | TourVesselInfo;

export interface AccommodationListProps {
  items: Array<AccommodationType>;
  initialVisible: number;
  heading?: string;
  hideNotice?: boolean;
}

const ReadMoreLabel = styled.span(({ theme }: ThemeProps) => ({
  marginRight: theme.custom.spacing.xSmall
}));

const Notice = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  marginBottom: theme.custom.spacing.xLarge
}));

const CardWrapper = styled.div(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xLarge,

  ['&:last-of-type']: {
    marginBottom: 0
  }
}));

export const AccommodationList = ({ items, initialVisible, heading, hideNotice }: AccommodationListProps) => {
  const t: any = useI18NextContext();
  const [expanded, setExpanded] = useState(false);
  const getReadMoreLabel = () => {
    return t(expanded ? 'common__description--view-less' : 'common__description--view-more');
  };
  const visibleItems: Array<AccommodationType> = expanded ? items : items.slice(0, initialVisible);

  return (
    <div data-testid={TestId.accommodationList.container}>
      <SectionTitle heading={t(heading || 'tour__information-title--accommodation')} />
      {!hideNotice && <Notice>{t('accommodation_list--notice-details')}</Notice>}
      {visibleItems.map((item: AccommodationType) => (
        <CardWrapper key={item.name}>
          <AccommodationCard {...item} />
        </CardWrapper>
      ))}
      {items.length > initialVisible && (
        <ReadMore data-testid={TestId.description.readMoreToggle} onClick={() => setExpanded(!expanded)}>
          <ReadMoreLabel data-testid={TestId.accommodationList.toggleView}>{getReadMoreLabel()}</ReadMoreLabel>
          <Icon name={expanded ? 'mhi-chevron-up' : 'mhi-chevron-down'} />
        </ReadMore>
      )}
    </div>
  );
};

AccommodationList.defaultProps = {
  initialVisible: 2
};
